import type { BetSlipState } from '../types';

const betSlipOpened = (state: BetSlipState, isOpen: boolean): BetSlipState => ({
  ...state,
  isOpen
});

export default betSlipOpened;
